var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.tabOptions),function(item){return _c('el-tab-pane',{key:item.id,attrs:{"label":item.name,"name":item.id}},[_vm._t(item.id)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }